import { ITableRes, ITeam, ITeamData, ITeamParams } from 'types'
import { baseApi } from './baseApi'
import { MAX_PER_PAGE } from 'utils/constants'

export const teamsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_teams: builder.query<ITableRes<ITeam>, ITeamParams>({
      query: (params) => ({
        url: '/group-course-teams/',
        params,
      }),
      providesTags: ['teams'],
    }),
    GET_teamsSelect: builder.query<ITableRes<ITeam>, ITeamParams>({
      query: (params) => ({
        url: '/group-course-teams/',
        params: {...params, page_size: MAX_PER_PAGE},
      }),
      transformResponse: (response: ITableRes<ITeam>): any => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['teams'],
    }),
    GET_teamById: builder.query<ITeam, string>({
      query: (id) => {
        return {
          url: `/group-course-teams/${id}/`,
        }
      },
      providesTags: ['team'],
    }),
    POST_team: builder.mutation<ITeam, ITeamData>({
      query: (body) => ({
        url: `/group-course-teams/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['teams', 'team'],
    }),
    PUT_team: builder.mutation<ITeam, { id: string; body: ITeamData }>({
      query: ({ id, body }) => ({
        url: `/group-course-teams/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['teams', 'team'],
    }),
    PATCH_team: builder.mutation<ITeam, { id: string; body: ITeamData }>({
      query: ({ id, body }) => ({
        url: `/group-course-teams/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['teams', 'team'],
    }),
    DELETE_team: builder.mutation<ITeam, string>({
      query: (id) => ({
        url: `/group-course-teams/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['teams'],
    }),
    PUT_addStudentToTeam: builder.mutation<ITeam, {id: string; student_id: string}>({
      query: ({id, student_id}) => ({
        url: `/group-course-teams/${id}/add-student/${student_id}/`,
        method: 'PUT',
      }),
      invalidatesTags: ['teams', 'team'],
    }),
    PUT_removeStudentFromTeam: builder.mutation<ITeam, {id: string; student_id: string}>({
      query: ({id, student_id}) => ({
        url: `/group-course-teams/${id}/remove-student/${student_id}/`,
        method: 'PUT',
      }),
      invalidatesTags: ['teams', 'team'],
    }), 
  }),
})

export const { 
  useGET_teamsQuery, 
  useGET_teamsSelectQuery, 
  useGET_teamByIdQuery, 
  usePOST_teamMutation, 
  usePUT_teamMutation, 
  usePATCH_teamMutation, 
  useDELETE_teamMutation, 
  usePUT_addStudentToTeamMutation, 
  usePUT_removeStudentFromTeamMutation, 
} = teamsAPI
